import React, { Component } from 'react'
import styled from 'styled-components'
import { Modal, Button, TextInput, Select } from 'advenio-components'
import { Form } from 'formsy-react' //eslint-disable-line

const Header = styled.div`
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  display: flex;
  margin-top: 8px;
`

const CloseButton = styled.img`
  position: absolute;
  right: 8px;
  top:8px;
  width: 10px;
  z-index: 300;
`

const HeaderTitle = styled.span`
  font-size: 20px;
  flex:1;
  text-align: center;
  margin: 0 20px 0 20px;
`

const Body = styled.div`
  margin-top:16px;
  display: flex;
  justify-content: center;
  padding: 8px;
`

const Timer = styled.input`
  outline: none;
  height: 40px;
  font-size: 24px;
  background-color: transparent;
  border: none;
`
const TimerContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 16px
  flex-direction: row;
`
const NewForm = styled(Form)`
  flex:1;
`
const hour = [{ value: 1, label: '1' }, { value: 2, label: '2' }, { value: 3, label: '3' }, { value: 4, label: '4' },
  { value: 5, label: '5' }, { value: 6, label: '6' }, { value: 7, label: '7' }, { value: 8, label: '8' },
  { value: 9, label: '9' }, { value: 10, label: '10' }, { value: 11, label: '11' }, { value: 12, label: '12' }]

const minutes = [{ value: '00', label: '00' }, { value: 15, label: '15' }, { value: 30, label: '30' }, { value: 45, label: '45' }]

const time = [{ value: 'AM', label: 'AM' }, { value: 'PM', label: 'PM' }]

class HourModal extends Component {


  getTwentyFourHourTime = (amPmString) => {
    const d = new Date("1/1/2013 " + amPmString)
    return this.addZero(d.getHours()) + ':' + this.addZero(d.getMinutes())
  }

  addZero = (i) => {
    if (i < 10) {
      i = "0" + i
    }
    return i
}

  sendMethod = (data) => {
    const timeSelected = data.hour + ':' + data.minutes + ' ' + data.time
    const { info, onSend } = this.props
    const newInfo = { hour: this.getTwentyFourHourTime(timeSelected), ...info }
    this.props.onSend(newInfo)
  }

  render() {
    return (
      <Modal isOpened={this.props.open} onClose={this.props.onClose} headerTitle="Seleccionar hora de inició de la comida">
        <Body>
          <NewForm onSubmit={this.sendMethod}>
            <TimerContainer>
              <Select
                name="hour"
                label="Hora"
                value={hour[0].value}
                options={hour}
              />
              <Select
                name="minutes"
                label="Minutos"
                value={minutes[0].value}
                options={minutes}
              />
              <Select
                name="time"
                label="Periodo"
                value={time[0].value}
                options={time}
              />
            </TimerContainer>
            <Button
              success
              fullWidth
              type="submit"
            >
              Confirmar
            </Button>
          </NewForm>
        </Body>
      </Modal>
    )
  }
}

export default HourModal



// WEBPACK FOOTER //
// ./src/Components/Activity/HourModal/index.jsx